module.exports = __webpack_public_path__ + "img/problem2.04ad5bee.png";